import React, { useContext, createContext } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import * as auditService from "api/services/auditService";

const LastAuditedYearContext = createContext({
  lastAuditedYear: 0,
  refetchLastAuditedYear: () => {},
});

const useLastAuditedYearContext = () => useContext(LastAuditedYearContext);

const LastAuditedYearProvider = ({ children }) => {
  const { data: backendData, refetch } = useQuery("lastAuditedYear", () =>
    auditService.getLastAuditedYear()
  );

  return (
    <LastAuditedYearContext.Provider
      value={{
        lastAuditedYear: backendData ?? 0,
        refetchLastAuditedYear: refetch,
      }}
    >
      {children}
    </LastAuditedYearContext.Provider>
  );
};

LastAuditedYearProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useLastAuditedYearContext, LastAuditedYearProvider };
